import moment from 'moment'

export default props => {
    if(!props.value) return null
    
    return moment(props.value).format('DD/MM/YYYY HH:mm')
}


// WEBPACK FOOTER //
// ./src/views/components/date/Date.js